'use client';

import { GoogleLogo } from 'icons/GoogleLogo';
import { trackOptimizelyEvent } from '@/app_lib/optimizely/utils';
import { useOptimizely } from '@/main/lib/hooks/useOptimizely';

export const GoogleSourceButton = () => {
  const { userFlags: userVariants, optimizely } = useOptimizely();
  const showGoogleBanner =
    (
      userVariants?.add_us_on_google_banner as {
        variant: string;
      }
    )?.variant === 'on';

  if (showGoogleBanner) {
    return null;
  }

  const openGooglePopup = () => {
    const url = 'https://www.google.com/preferences/source?q=fortune.com';
    const windowFeatures = 'menubar=no,toolbar=no,status=no,width=600,height=600,top=100,left=100';

    window.open(url, 'GooglePopup', windowFeatures);
  };

  return (
    <button
      className='flex justify-center items-center gap-2 cursor-pointer'
      onClick={() => {
        trackOptimizelyEvent(optimizely, 'addOnGoogleClicked', {});
        openGooglePopup();
      }}
      type='button'
    >
      <div className='button-tertiary-accent font-graphik-compact typography-sm font-medium underline whitespace-nowrap'>
        Add us on
      </div>
      <GoogleLogo className='w-4 h-4' />
    </button>
  );
};
